import React from 'react'
import classNames from 'classnames'
import cls from './top-message-line.module.scss'
import { useMember } from '~src/new/app/providers/MemberProvider'

export const TopMessageLine = ({ labels, className, contentComponentName }) => {
  const { isGuest, isArchiveAccount } = useMember()
  const isLoginPage = contentComponentName === 'LoginPageMobilephone'
  const shouldShow = isArchiveAccount || isGuest

  if (!shouldShow || isLoginPage) return null

  const message = isArchiveAccount
    ? labels?.ARCHIVE_ACCOUNT_NOTIFICATION
    : labels?.GUEST_USER_NOTIFICATION

  return (
    <div className={cls.lineWrapper}>
      <div className={classNames(cls.line, className)}>{message}</div>
    </div>
  )
}
